export default function (): string {
    return useNuxtApp().$i18n?.locale.value.split('-')[0] || 'en'
}
